/* eslint-disable max-len */

export var DEFAULT_WIDGET_TITLE = 'Пополнение счёта';
export var PAYMENT_METHODS = {
  linkText: 'все способы оплаты',
  link: '/customers/finansy-oplata/popolnenie-scheta/'
};
export var ERROR_TEXTS = {
  required: 'Обязательное поле',
  invalidPhone: 'Введите номер телефона',
  invalidAccountNumber: 'Введите номер лицевого счета'
};
export var VALIDATION_TEXTS = {
  required: 'Обязательное поле',
  invalidData: 'Некорректно введена сумма',
  lessThanMin: 'Минимальная сумма',
  moreThanMax: 'Максимальная сумма'
};
export var LINKED_CARD_POPUP = {
  Success: {
    img: {
      src: 'https://static.beeline.ru/upload/images/icons/3854-cat_success_sberpay.svg',
      lazy: false,
      alt: 'успех'
    },
    title: 'через пару минут на балансе',
    button: {
      text: 'вернуться на сайт'
    }
  },
  Error: {
    img: {
      src: 'https://static.beeline.ru/upload/images/icons/3854-cat_error_sberpay.svg',
      lazy: false,
      alt: 'ошибка'
    },
    title: 'пополнить иначе',
    button: {
      text: 'понятно'
    }
  },
  ServerError: {
    img: {
      src: 'https://static.beeline.ru/upload/images/b2c/sfp-statuses-icons/error.svg',
      lazy: false,
      alt: 'ошибка'
    },
    title: 'что-то пошло не так',
    description: 'попробуйте повторить позднее',
    button: {
      text: 'понятно'
    }
  },
  SMS: {
    title: 'введите код из SMS',
    subtitle: 'код отправлен на номер {{phone}}',
    button: 'подтвердить номер',
    resend: 'отправить код повторно',
    error: {
      incorrect: 'неверный код',
      limit: 'превышен лимит'
    }
  }
};
export var FORM_TEXTS = {
  trustedPayment: {
    link: '/customers/products/mobile/services/details/doveritelnyy-platezh/',
    linkText: 'Получить доверительный платеж'
  },
  paymentMethods: {
    link: '/customers/finansy-oplata/popolnenie-scheta/',
    linkText: 'все способы оплаты'
  },
  RU: {
    ctnLabelMobile: 'Номер получателя',
    ctnLabelHome: 'Номер лицевого счёта',
    amount: 'Сумма',
    paymentMethod: 'Способ оплаты',
    commission: '100–15 000 ₽ без комиссии',
    cantCheck: 'Для абонентов билайн',
    notBeeline: 'Абонент не принадлежит сети билайн.',
    buttonText: 'К пополнению',
    alterButton: 'Оплатить картой',
    success: 'Счёт пополнен!',
    error: 'Не получилось оплатить',
    offeroApple: 'Нажимая Pay, я принимаю <a class="offer-link" href="https://beeline.ru/customers/pomosh/question/voprosy-i-dokumenty/mobile/drugie-dokumenty/pravila-ispolzovania-servisa-mobilnyy-platezh/" target="_blank" rel="noopener">условия</a> использования услуги',
    offeroGoogle: 'Нажимая GPay, я принимаю <a class="offer-link" href="https://beeline.ru/customers/pomosh/question/voprosy-i-dokumenty/mobile/drugie-dokumenty/pravila-ispolzovania-servisa-mobilnyy-platezh/" target="_blank" rel="noopener">условия</a> использования услуги',
    offeroSfp: 'Нажимая «Оплатить через СБП», я принимаю <a class="offer-link" href="https://beeline.ru/customers/pomosh/question/voprosy-i-dokumenty/mobile/drugie-dokumenty/pravila-ispolzovania-servisa-mobilnyy-platezh/" target="_blank" rel="noopener">условия</a> использования услуги'
  },
  EN: {
    ctnLabelMobile: 'Payment recipient',
    ctnLabelHome: 'Account number',
    amount: 'Amount',
    commission: 'From 100 to 15000 RUB',
    cantCheck: 'Unable to verify number. Try again later',
    notBeeline: 'Not Beeline number',
    buttonText: 'Submit',
    alterButton: 'Pay with card',
    success: 'Success!',
    error: 'Failed to pay',
    offeroApple: 'Clicking Pay, I accept the service <a href="https://static.beeline.ru/upload/images/promoforge/docs/oferta_Apple_Pay_eng.pdf" target="_blank" rel="noopener">terms</a> and conditions',
    offeroGoogle: 'Clicking GPay, I accept the service <a href="https://static.beeline.ru/upload/images/promoforge/docs/oferta_Google_Pay_eng.pdf" target="_blank" rel="noopener">terms</a> and conditions'
  }
};
var ava = ['card', 'sber', 'apple', 'google'];
['sfp', 'sber', 'card', 'apple', 'google'].sort(function (a, b) {
  return ava.indexOf(b) - ava.indexOf(a);
});